//Minimum screen height below which alternative layout kicks in
export const minimumScreenHeight = 900

export const DARK_MODE = 'dark'
export const LIGHT_MODE = 'light'
